"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var IconButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(IconButton, _React$Component);

  var _super = _createSuper(IconButton);

  function IconButton() {
    (0, _classCallCheck2["default"])(this, IconButton);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(IconButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          icon = _this$props.icon,
          color = _this$props.color,
          link = _this$props.link,
          size = _this$props.size;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        icon: icon,
        color: color,
        as: link && 'a',
        href: link,
        size: size
      });
    }
  }]);
  return IconButton;
}(_react["default"].Component);

exports["default"] = IconButton;
IconButton.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string,
  link: _propTypes["default"].string,
  size: _propTypes["default"].string
};
IconButton.defaultProps = {
  color: 'grey',
  link: '',
  size: 'medium'
};